"use strict";

import angular from "angular";

export class NewsPopUpDialogCtrl {
    constructor(locals, $mdDialog) {
        this.locals = locals;
        this.popup = locals.popup;
        this.$mdDialog = $mdDialog;
    }

    $oninit() {}
}

angular.module("nucont.shared").controller("NewsPopUpDialogCtrl", [
        "locals",
        "$mdDialog",
        NewsPopUpDialogCtrl
    ]);
